// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"search-box_searchBox__3TN7C"};